import { useQuery } from "@tanstack/react-query";
import UserApi from "../api/manageUserApi";

export const useUsersData = ({
  page,
  limit,
  queryString = "",
  queryParams = "",
  ofCompany,
  sort = "-createdAt",
}) => {
  const { data, isLoading, isError, error, isFetching } = useQuery({
    queryKey: ["users", page, limit, queryString, queryParams, ofCompany, sort], // Ensure `page` is part of the key
    queryFn: () =>
      UserApi.fetchUsers({
        page,
        limit,
        queryString,
        queryParams,
        ofCompany,
        populate: "role,ofCompany",
        selectPopulate: "name",
        sort,
        fields:"-reminders"
      }), // Use `page` directly
    keepPreviousData: true, // Retain previous data during fetching
    staleTime: Infinity, // Cache duration
  });

  return { data, isLoading, isError, error, isFetching };
};
